import { gate as v3Gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
export const SETTINGS_ROUTER_GATE = v3Gate('ConnectedApps::SettingsRouter');
export const getAppSettingsUrl = ({
  appId,
  portalId
}) => {
  const integrationsSettingsUrl = `/integrations-settings/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/installed/application/${appId}`;
  try {
    if (userInfoSync().gates.includes(SETTINGS_ROUTER_GATE)) {
      return `/integration/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/settings/${appId}`;
    }
    return integrationsSettingsUrl;
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        appId,
        portalId
      }
    });
    return integrationsSettingsUrl;
  }
};